import axios from "axios";
import {ReservationModel} from "@/model/reservation.model";
import {AxiosUtils} from "@/axios-utils";
import VueRouter from "vue-router";

export class ReservationUtils {

    /**
     * 予約情報を取得します。
     * エラー時にはエラー画面に遷移します。
     * @param router ルーター
     * @param reservation 予約情報
     * @param callback 予約情報取得後（正常時）に実行するコールバック関数（HTTPステータスコード、予約情報）
     */
    public static getReservationInfo(router: VueRouter, reservation: ReservationModel, callback: (status: number, reservation: any) => void) {
        axios.get(`/reservation?reservationId=${reservation.reservationId}&reservationKey=${reservation.reservationKey}`)
            .then(cb => {
                callback(cb.status, cb.data)
            })
            .catch(error => AxiosUtils.gotoClientErrorPage(error, router));
    }

    /**
     * 会員情報の登録後、予約の紐付け処理を実行します。
     * エラー時にはエラー画面に遷移します。
     * @param reservation 予約情報
     * @param callback 処理実行後（正常時）に実行するコールバック関数（HTTPステータスコード）
     */
    public static registerUserInfoAndlinkReservation(router: VueRouter, reservation: ReservationModel, callback: (status: number) => void) {
        axios.post("/reservation", reservation)
            .then(cb => {
                callback(cb.status)
            })
            .catch(error => AxiosUtils.gotoClientErrorPage(error, router));
    }
}